import React from "react";
import { cn } from "../../../utils/cn";
import type { HourlyWeather } from "../agendaWeatherTypes";
import {
  WEATHER_RAIN_PILL_THRESHOLD,
  rainPillClassName,
  rainPillTier,
  weatherConditionIcon,
} from "../weatherConditionUi";

type WeatherHourCellProps = {
  hour?: HourlyWeather;
};

const WeatherHourCell: React.FC<WeatherHourCellProps> = ({ hour }) => {
  if (!hour) {
    return <div className="h-8" aria-hidden />;
  }

  const tier = rainPillTier(hour.rainChance);
  const Icon = weatherConditionIcon(hour.condition);

  if (hour.rainChance >= WEATHER_RAIN_PILL_THRESHOLD) {
    return (
      <div className="flex h-8 items-center justify-center">
        <span
          className={cn(
            "inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none",
            rainPillClassName(tier)
          )}
        >
          <Icon className="h-3 w-3 shrink-0" aria-hidden />
          {hour.rainChance}%
        </span>
      </div>
    );
  }

  return (
    <div className="flex h-8 items-center justify-center gap-1 text-[12px] font-medium text-[#4A5568]">
      <Icon className="h-3.5 w-3.5 shrink-0 text-[#718096]" aria-hidden />
      <span>{hour.temperatureC}°</span>
    </div>
  );
};

export default WeatherHourCell;
